import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { useUiStore } from '@/store/uiStore';

export const WelcomeModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.welcome);
  const closeModal = useUiStore((state) => state.closeModal);
  const navigate = useNavigate();

  const handleStartChatting = () => {
    closeModal('welcome');
    const utmSlug = sessionStorage.getItem('utm_echo_slug');
    sessionStorage.removeItem('utm_echo_slug');
    navigate(utmSlug ? `/messages/${utmSlug}` : '/home');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => closeModal('welcome')}
      className='border-0'
      style={{
        background:
          'linear-gradient(180deg, rgba(255, 255, 255, 0) -1.92%, #A28DF6 140.84%), #FFFFFF',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div className='flex flex-col items-center gap-6 pt-2 text-center'>
        <div className='flex flex-col gap-2'>
          <h2 className='font-proxima text-24 font-bold leading-25 tracking-normal text-brand-800'>
            Welcome to DECHO.
          </h2>
          <p className='mt-4 font-sans text-16 font-normal leading-21 text-gray-600'>
            You&apos;re all set. Start exploring, creating, and chatting.
          </p>
        </div>

        <Button
          onClick={handleStartChatting}
          variant='sidebar-default'
          width={169}
          height={49}
          className='font-sans text-[18px] font-semibold leading-[27px] text-brand-800'
        >
          Start Chatting
        </Button>
      </div>
    </Modal>
  );
};
